import React, { useState, useEffect } from "react";
import FlatList from "flatlist-react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import AppStyles from "../../config/styles";
import { RenderChildList, AddRecipients, AddChildCloseIcon, OuterView, AddRecipientsInner} from "../atoms/ConnectStories";
import SearchViewComponent from "../molecule/searchView";
import SEARCHICON from "../../images/search-icon.svg";
import ADDICON from "../../images/addicon.svg";
import REMOVEICON from "../../images/removeicon.svg";
import SENSITIVEAREAICON from "../../images/red-indicator.svg";
import PLACEHOLDER from "../../images/PlaceholderImage.png";
import MODALHEADERICON from "../../images/modal.svg";

const styles ={
  viewLine: {
    alignSelf: "center",
    backgroundColor: AppStyles.colors.COLOR_GREYE6,
    marginTop: "6px",
    height: "4px",
    width: "96px",
  },
  titlestyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "28px",
    color: "black",
    marginBottom: "10px",
    textAlign: "center",
  },
  desstyle: {
    fontFamily: "Lato",
    textAlignVertical: "center",
    fontSize: "16px",
    color: "black",
    textAlign: "center",

  },
  saveviewstyle: {
    borderRadius: "8px",
    backgroundColor: AppStyles.colors.COLOR_ORANGE,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    padding:"2vh",
    left: "30%",
  },
  savetextstyle: {
    color: AppStyles.colors.COLOR_WHITE,
    fontSize: "18px",
    fontFamily: "Lato-Bold",
    cursor:"pointer"
  },
  searchstyle: {
    border: "1px solid #666666",
    marginTop: "20px",
    paddingTop: "8px",
    paddingBottom: "8px",
    width: "30vw",
    position: "relative",
    left: "9vw",
  },
  iconsearchstyle: {
    height: "15px",
    width: "15px",
    marginLeft: "10px",
  },
  inputstyle: {
    color: AppStyles.colors.COLOR_BLACK,
    fontSize: "14px",
    fontFamily: "Lato-Bold",
    paddingVertical: 0,
  },
  childinnerviewstyle: {
    flexDirection: "row",
    flex: 1,
    alignItems: "center",
    padding: "3px",
    borderRadius: "70px",
    marginLeft: "20px",
    border: "1px solid rgba(17, 17, 17, 0.5)",
    paddingRight: "10px",
    width: "max-content",
  },
  childinnerselectedviewstyle: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    padding: 3,
    backgroundColor: AppStyles.colors.COLOR_LIGHTORANGE,
    borderRadius: 70,
    border: "1px solid AppStyles.colors.COLOR_LIGHTORANGE",
    paddingRight: "10px",
    marginLeft: "20px",
    width: "max-content",
  },
  childnamestyle: {
    color: AppStyles.colors.COLOR_BLACK,
    fontSize: "18px",
    fontFamily: "Lato-Bold",
    marginLeft: "7px",
    marginRight: "7px",
    flex: 1,
  },
  childImgStyles: {
    width: 41,
    height: 41,
    borderRadius: 41 / 2,
  },
  flatlistStyle: {
    marginTop: "30px",
    marginBottom: "20px",
    marginLeft: "40px",
    marginRight: "40px",
    flexGrow: 0,
  },
  iconstyle: {
    alignSelf: "flex-end",
    marginRight: "15px",
  },
  sensitiveiconstyle: {
    position:"absolute",
    width: "15px",
    height:"15px",
    right:"5px",
    top:"-6px",
    border: "2px solid #fff",
    borderRadius: "50%",
    boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 3px 0px",
  },
  modalHeaderIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalHeaderIconDiv: {
    background: "#FDDFCA",
    borderRadius: "50%",
    position: "relative",
  },
  hr:{
    width:"92%",
    color:"rgba(0, 0, 0, 0.8)",
    margin:"auto",
    marginTop:"25px",
    marginBottom:"25px"
  }
};

export function AddRecipientsModal(props) {
  const [filteredChildList, setFilteredChildList] = useState(null);
  
  const { t } = useTranslation();
  const SerachIcon = <img src={SEARCHICON} style={styles.iconsearchstyle} alt=""/>;

  const searchChildList = (searchText, childListValue) => {
    if (searchText?.trim() === "") {
      return childListValue;
    }
    const filtered = childListValue.filter(
      (item) => item.childFirstName?.toLowerCase().includes(searchText?.trim().toLowerCase()),
    );
    return filtered;
  };

  const searchChild = (searchtext) => {
    setFilteredChildList(
      searchChildList(searchtext, props?.childList),
    );
  };

  useEffect(() => {
    if (props?.childList && props?.childList?.length > 0) {
      setFilteredChildList(props?.childList);
    }
  }, [props?.childList, props?.isVisible]);

  const getSelectedIcon = (item) => {
    if (item?.isSelected) {
      return (<img src={REMOVEICON} alt=""/>);
    }
    return (<img src={ADDICON} alt=""/>);
  };

  const getSensitiveIcon = (item) => {
    if (item?.sensitivity == 1 || item?.sensitivity == 2) {
      return (<img src={SENSITIVEAREAICON} style={styles.sensitiveiconstyle} alt=""/>);
    }
    return null;
  };

  const onChildSelected = (item, index) => {   
    const filteredlist = [...filteredChildList];
      filteredlist[index].isSelected = !filteredlist[index].isSelected;
      setFilteredChildList(filteredlist);
  };

  const renderListItem = ( item, index ) => (
      <RenderChildList onClick={() => onChildSelected(item, index)}>
        <div style={(item?.isSelected) ? styles.childinnerselectedviewstyle: styles.childinnerviewstyle}
        >
          <img
            alt=""
            style={styles.childImgStyles}
            src={item?.childImageURL ? item.childImageURL : PLACEHOLDER}
          />
          <span style={styles.childnamestyle} >{item.childFirstName}</span>
          {getSelectedIcon(item,index)}
        </div>
        {getSensitiveIcon(item)}
      </RenderChildList>
  );

  return (
    <Modal
      show={props?.isVisible}
      onHide={props?.onClose}
      className="add-child-popup recipient"
    >
        <AddChildCloseIcon  onClick={props?.onClose}>X</AddChildCloseIcon>
      <div>
      <div style={styles.modalHeaderIcon}>
          <div style={styles.modalHeaderIconDiv} className="modal-header-icon">
            <img
              src={MODALHEADERICON}
              alt="modal header"
            />
          </div>
        </div>
        <p style={styles.titlestyle}>{t("AddRecipients")}</p>
        <p style={styles.desstyle}>{t("AddRecipientsDescription")}</p>
        <hr style={styles.hr}/>
        <SearchViewComponent
          placeholderText={t("SearchName")}
          enableSerach
          containerstyle={styles.searchstyle}
          searchCallBack={(searchtext) => searchChild(searchtext)}
          icon={SerachIcon}
          inputstyle={styles.inputstyle}
        />
        <OuterView>
        <FlatList
          list={filteredChildList}
          keyExtractor={(item) => item.childCode}
          showsVerticalScrollIndicator={false}
          style={styles.flatlistStyle}
          renderItem={renderListItem}
        />
        </OuterView>
        <AddRecipients onClick={() => props?.onAddRecipients(props?.childList)}>
          <AddRecipientsInner>
            <span style={styles.savetextstyle}>
              {t("SaveRecipient", { count: props?.childList?.filter((x) => x.isSelected)?.length })}
            </span>
          </AddRecipientsInner>
        </AddRecipients>
      </div>
    </Modal>
  );
}

export default AddRecipientsModal;
